import * as React from 'react';
import { useMenuContext } from "../useMenuContext";

var useMenuItem = function useMenuItem(props) {
  var externalRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var onMouseEnterProp = props.onMouseEnter,
      onMouseMoveProp = props.onMouseMove,
      onMouseLeaveProp = props.onMouseLeave,
      onClickProp = props.onClick,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  var menu = useMenuContext();
  var setFocusedIndex = menu.setFocusedIndex,
      focusedIndex = menu.focusedIndex,
      closeOnSelect = menu.closeOnSelect,
      onClose = menu.onClose,
      register = menu.register,
      unregister = menu.unregister,
      menuItems = menu.menuItems,
      palette = menu.palette;
  var ref = React.useRef(externalRef);
  var element = ref.current;
  var setRef = React.useCallback(function (node) {
    if (ref.current) {
      unregister(ref.current);
    }

    if (node) {
      register({
        element: node,
        disabled: disabled
      });
    }

    ref.current = node; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var index = element ? menuItems.findIndex(function (item) {
    return item.element === element;
  }) : -1;
  var focused = index === focusedIndex;
  var isFocusable = focused && !disabled;
  var onMouseEnter = React.useCallback(function (event) {
    onMouseEnterProp === null || onMouseEnterProp === void 0 ? void 0 : onMouseEnterProp(event);
    !disabled && setFocusedIndex(index);
  }, [onMouseEnterProp, disabled, setFocusedIndex, index]);
  var onMouseMove = React.useCallback(function (event) {
    onMouseMoveProp === null || onMouseMoveProp === void 0 ? void 0 : onMouseMoveProp(event);

    if (document.activeElement !== ref.current) {
      onMouseEnter(event);
    }
  }, [onMouseEnter, onMouseMoveProp]);
  var onMouseLeave = React.useCallback(function (event) {
    onMouseLeaveProp === null || onMouseLeaveProp === void 0 ? void 0 : onMouseLeaveProp(event);
    !disabled && setFocusedIndex(-1);
  }, [onMouseLeaveProp, disabled, setFocusedIndex]);
  var onClick = React.useCallback(function (event) {
    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }

    onClickProp === null || onClickProp === void 0 ? void 0 : onClickProp(event);
    closeOnSelect && onClose();
  }, [closeOnSelect, disabled, onClickProp, onClose]);
  return {
    ref: setRef,
    isFocusable: isFocusable,
    onMouseLeave: onMouseLeave,
    onMouseMove: onMouseMove,
    onMouseEnter: onMouseEnter,
    onClick: onClick,
    palette: palette,
    disabled: disabled
  };
};

export { useMenuItem };
export default useMenuItem;